import { render, staticRenderFns } from "./BotaoRastreabilidadeDashboardBungeSubEmpresa.vue?vue&type=template&id=744f97ad&lang=pug"
import script from "./BotaoRastreabilidadeDashboardBungeSubEmpresa.vue?vue&type=script&lang=js"
export * from "./BotaoRastreabilidadeDashboardBungeSubEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports